(function () {
  window.__BUNDLE__ = window.__BUNDLE__ || {};
  let guest = null;
  window.__BUNDLE__.getGuest = (index = 'ssfguest') => {
    if (guest) return guest;
    window.__ICE__ = {
      diagnosticsUrl: 'https://int.api.ellielabs.com/diagnostics/v2/logging',
    };
    guest = new ice.guest.SSFGuest({
      logger: {
        // console: true,
        index,
        team: 'ui platform',
        appName: 'guest app',
      },
    });
    // set debug loglevel
    // guest.setLogLevel(10)
    return guest;
  };
})();
